import { Link } from "react-router-dom";
import Header from "../components/Common/Header";

function NotFound() {
  return (
    <div className="min-h-screen bg-vault-50">
      <Header />

      <main className="mx-auto flex max-w-7xl flex-col items-center justify-center px-4 py-24 text-center sm:px-6 lg:px-8">
        <div className="text-vault-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="mx-auto h-24 w-24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
            />
          </svg>
        </div>
        <h1 className="mt-6 font-serif text-4xl font-bold text-vault-900">
          Page Not Found
        </h1>
        <p className="mt-4 text-lg text-vault-600">
          Sorry, we couldn&apos;t find the page you&apos;re looking for.
        </p>
        <Link to="/" className="btn-primary mt-8">
          Go back home
        </Link>
      </main>
    </div>
  );
}

export default NotFound;

